module.exports = __webpack_public_path__ + "img/main-03-04.9f7246e2.png";